import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-passwords', {
        url: '/shared-passwords',
        component: 'companySharingCenterSharedPasswords',
        resolve: {companyId, accounts, allAccounts},
    });
}

/** @ngInject */
function allAccounts(companyId, SharedAccountsService) {
    return SharedAccountsService
        .getAllByCompany({companyId}, {});
}

/** @ngInject */
function accounts($filter, allAccounts) {
    return allAccounts.$promise
        .then(accounts => accounts.filter(account => !account.enabled2fa))
        .then(accounts => $filter('orderBy')(accounts, 'publicService.serviceName'))
        .then(accounts => accounts.map((account) => ({...account, serviceDisplayName: serviceDisplayName(account)})))
}

function serviceDisplayName(account) {
    let displayName = '';
    if (account.publicService.slug != 'other' || !account.customServiceName) {
        displayName = account.publicService.serviceName;
    } else if (account.publicService.slug == 'other'){
        displayName = account.customServiceName;
    }
    return displayName;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/shared-passwords.state.js